export default __webpack_public_path__ + "static/media/MapLegendJa.29c6d502.svg";